(function(){
  'use strict';
  function openQuote(){
    var original=document.getElementById('open-quoter-modal-btn');
    if(original && !original.disabled){original.click();return;}
    var section=document.querySelector('.mlc-pdp .product-form');
    if(section)section.scrollIntoView({behavior:'smooth',block:'center'});
  }
  function refreshMobilePrice(){
    var main=document.querySelector('.mlc-pdp [id^="price-"]');
    var mobile=document.querySelector('.mlc-pdp-mobile-quote [data-mlc-price]');
    if(!main || !mobile)return;
    var current=main.querySelector('.price-item--sale')||main.querySelector('.price__regular .price-item--regular')||main.querySelector('.price-item');
    if(current && current.textContent.trim()) mobile.textContent=current.textContent.trim();
  }
  function initialize(){
    document.querySelectorAll('[data-mlc-open-quote]').forEach(function(el){
      if(el.dataset.mlcReady)return;
      el.dataset.mlcReady='1';
      el.addEventListener('click',openQuote);
    });
    var main=document.querySelector('.mlc-pdp [id^="price-"]');
    if(main && !main.dataset.mlcPriceWatch){
      main.dataset.mlcPriceWatch='1';
      var observer=new MutationObserver(refreshMobilePrice);
      observer.observe(main,{subtree:true,childList:true,characterData:true});
    }
    refreshMobilePrice();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
}());